declare var require: any;
export const TemplateFieldConstants = require('../../../assets/i18n/en.json').TEMPLATE_NAME_CONSTANT;
export const MessagesData = require('../../../assets/i18n/en.json').MESSAGES;
